import React, { useCallback, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import SectionCard from './ui/SectionCard';
import PartidaHistoricoCard from './PartidaHistoricoCard';
import api from '../api';
import useTempoReal from '../utils/tempoReal';

const VISIVEIS = 5;

/**
 * Histórico das partidas da pelada em andamento (tela de Partidas, abaixo das estatísticas): a mais recente
 * primeiro, no mesmo cartão do Ranking. Recarrega quando a partida em campo muda (`atualizarCom`: resultado
 * registrado ou desfeito) e pelo tempo real. `podeExcluir` (diretoria): lixeira em cada partida.
 */
const HistoricoPartidasPelada = ({ peladaId, atualizarCom, podeExcluir }) => {
  const [partidas, setPartidas] = useState([]);
  const [todas, setTodas] = useState(false);
  const [aviso, setAviso] = useState(null);

  const carregar = useCallback(() => {
    if (!peladaId) return;
    api
      .get(`report/patidas?peladaId=${peladaId}&limit=100`)
      .then(({ data }) => setPartidas((data.partidas || []).map((p, i) => ({ ...p, numero: i + 1 })).reverse()))
      .catch(() => {});
  }, [peladaId]);

  useEffect(() => {
    carregar();
  }, [carregar, atualizarCom]);

  const excluir = async (partida) => {
    try {
      await api.remove(`partidas/${partida._id}`);
      setAviso({ severity: 'success', texto: `Partida ${partida.numero} excluída.` });
      carregar();
    } catch (error) {
      setAviso({ severity: 'error', texto: error.response?.data?.message || 'Não foi possível excluir a partida.' });
    }
  };

  useTempoReal((canais) => {
    if (!canais || canais.includes('partida')) carregar();
  });

  if (partidas.length === 0 && !aviso) return null;
  const mostradas = todas ? partidas : partidas.slice(0, VISIVEIS);

  return (
    <SectionCard title="Histórico de partidas" subtitle={`${partidas.length} ${partidas.length === 1 ? 'partida encerrada' : 'partidas encerradas'} nesta pelada · a mais recente primeiro`}>
      {aviso && <Alert severity={aviso.severity} onClose={() => setAviso(null)} sx={{ mb: 1.5 }}>{aviso.texto}</Alert>}
      <Stack spacing={1.5}>
        {mostradas.map((partida) => (
          <PartidaHistoricoCard key={partida._id} partida={partida} numero={partida.numero} onExcluir={podeExcluir ? excluir : undefined} />
        ))}
      </Stack>
      {partidas.length > VISIVEIS && (
        <Button fullWidth sx={{ mt: 1.5 }} onClick={() => setTodas((v) => !v)}>
          {todas ? 'Mostrar só as últimas' : `Ver todas (${partidas.length})`}
        </Button>
      )}
    </SectionCard>
  );
};

export default HistoricoPartidasPelada;
